import React from "react";
import { useSolrContext } from "@e-fork/solr";
import { FormattedMessage } from "react-intl";
import useTranslate from "@default/hooks/use-translate";
import Status from "@default/general-components/status/status";

const Error = () => {
  const { error } = useSolrContext();
  const _t = useTranslate();

  if (!error) return null;

  return (
    <Status
      type="error"
      title={_t("overview.status.error.title")}
      message={_t("overview.status.error.message")}
      direction="vertical"
    />
  );
};

export default Error;
